import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeftIcon } from '@heroicons/react/24/outline'
import { Box } from '@mui/material'
import { Button } from '../../../interaxDesignSystemComponents'
import { INTERAX_COLORS } from '../../../constants/colors'
import { TeamInformationSharesLineChartContainer } from '../components/GenerateReport/visualizations/teamInformationShares'

/**
 * Dev Tools page for testing Team Information Shares Line Chart
 */
export const TeamInformationSharesDevTest: React.FC = () => {
  const navigate = useNavigate()

  const handleBack = () => {
    navigate(-1)
  }

  return (
    <Box sx={{ padding: '24px', backgroundColor: INTERAX_COLORS.offBlack, minHeight: '100vh' }}>
      {/* Header with back button */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '32px' }}>
        <Button variant="secondary" onClick={handleBack} icon={<ArrowLeftIcon className="w-4 h-4" />} />
        <Box className="text-headline-1" sx={{ color: INTERAX_COLORS.white }}>
          Team Information Shares Line Chart - Dev Test
        </Box>
      </Box>

      {/* Chart Container */}
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <TeamInformationSharesLineChartContainer />
      </Box>
    </Box>
  )
}
